module.exports = "<!--\r\nAuto-generated\r\nDo not edit!!!\r\n-->\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/group-service/group-service-details/group-service-details.view.component.html
// module id = ../../../../../src/app/modules/group-service/group-service-details/group-service-details.view.component.html
// module chunks = main